/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import MediaQuery from 'react-responsive';
import { Sticky, StickyContainer } from 'react-sticky';
import LoadingSpinner from '../Layout/LoadingSpinner';
import {
  fetchEbook,
  fetchResource,
  getCourseDetail,
  getCourseDetailHostedLoggedIn,
  isLoggedIn,
  removeScript,
} from '../Utils/Utils';
import CourseExam from '../components/CourseExam';
import CertificatesFreeCourse from '../components/CourseExam/CertificatesFreeCourse';
import ExamFinish from '../components/CourseExam/ExamFinish';
import ExamFinishPerLecture from '../components/CourseExam/ExamFinishPerLecture';
import ExamFinishPretest from '../components/CourseExam/ExamFinishPretest';
import ExamImprovement from '../components/CourseExam/ExamImprovement';
import QuizPerLecture from '../components/CourseExam/QuizPerLecture';
import CourseModal from '../components/CourseModal';
import CourseNav from '../components/CourseNav';
import QnA from '../components/CourseNav/QnA';
import CourseResource from '../components/CourseResource';
import CourseEbook from '../components/CourseResource/CourseEbook';
import CourseVideo from '../components/CourseVideo';
import Footer from '../components/Footer';
import Header from '../components/Header/Header';
import Person from '../components/Person';
import Title from '../components/Title';

import { Button } from 'antd';
import axios from 'axios';
import moment from 'moment';
import { NotificationManager } from 'react-notifications';
import HowToDownload from '../components/HowToDownload';

import { API_URL, KPJ_CODE_ADMIN } from '../constant';
import KpjCodeVerification from './KpjCodeVerification';

import { URL_MES_COURSE } from 'src/constants';
import styled from 'styled-components';

const ACCENT = '#FF0F51';

export const BadgeSubs = styled.div`
  color: ${ACCENT};
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
`;

export const WrapperSubs = styled.div`
  padding: 10px 0 10px 0;

  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: 1024px) {
    padding: 20px 0 10px 0;
  }
`;

function CourseDetail(props) {
  const {
    dispatch,
    materiExamOpened,
    quiz_score_data,
    isLoading,
    lesson_detail_number,
    lecture_number,
    resource_lecture_id,
    certificate_failed,
    match,
    history,
  } = props;

  const slug = match.params.slug;

  const userData = useSelector((state) => state.profile_data);

  const packageSub = userData?.mes_subscription ?? '';

  const mesxGrantedCourse = packageSub?.mesx_granted_course_id ?? [];

  const [course_detail, setCourseDetail] = useState(null);

  const isUsingSubs = mesxGrantedCourse?.includes(course_detail?.id);
  const isActiveSub = packageSub?.is_active === true;

  const [courseModalOpen, setCourseModalOpen] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [class_resource, setClassResource] = useState(null);
  const [kpj_code, setKpjCode] = useState('');
  const [loadingVoucherKpj, setLoadingVoucherKpj] = useState(false);
  const [loadingTugasMandiri, setLoadingTugasMandiri] = useState(false);

  const dateParse = (date = new Date()) => moment(date).utcOffset(7).format();

  const dispatchToStore = (courseDetailData, courseEbookData, profileData) => {
    dispatch({
      type: 'ADD_COURSEDETAIL',
      payload: courseDetailData,
    });
    dispatch({
      type: 'SET_COURSE_EBOOK',
      payload: courseEbookData,
    });
    dispatch({
      type: 'ADD_BANNERDETAIL',
      payload: courseDetailData.name,
    });
    dispatch({
      type: 'ADD_PROFILEDATA',
      payload: profileData,
    });
  };

  // componentDidMount
  useEffect(() => {
    let isMounted = true;

    const init = async () => {
      try {
        dispatch({ type: 'TOGGLE_LOADING_TRUE' });

        const user_check_api = await isLoggedIn();
        let profileDataLocal = user_check_api.profile_data;

        const course_detail_hosted = await getCourseDetailHostedLoggedIn(slug);
        const course_ebook_data = await fetchEbook(slug);

        if (!isMounted) return;

        let courseDetailLocal = course_detail_hosted;
        let courseEbookLocal = course_ebook_data;

        // Redirect if not logged in
        if (!profileDataLocal) {
          window.location.href = '/';
          return;
        }

        // If hosted detail null, fallback to getCourseDetail
        if (courseDetailLocal === null) {
          const fallbackCourseDetail = await getCourseDetail(slug);
          if (!isMounted) return;

          courseDetailLocal = fallbackCourseDetail;

          if (courseDetailLocal === null) {
            window.location.href = '/';
            return;
          }
        }

        // Handle live course redirect
        if (courseDetailLocal && courseDetailLocal.type === 'live') {
          if (courseDetailLocal.course_schedule_register) {
            if (courseDetailLocal.course_schedule_register.schedule) {
              if (
                dateParse(courseDetailLocal.course_schedule_register.schedule.end_date) >
                dateParse()
              ) {
                window.location.href = '/student/course';
                return;
              }
            } else {
              window.location.href = '/student/course';
              return;
            }
          } else {
            window.location.href = '/student/course';
            return;
          }
        }

        // Handle ratings is_finalized
        if (courseDetailLocal && profileDataLocal && courseDetailLocal.ratings) {
          let is_finalized = 0;
          if (courseDetailLocal.ratings[0]) {
            courseDetailLocal.ratings.forEach((el) => {
              if (el.user_id === profileDataLocal.id) {
                is_finalized = el.is_finalized;
              }
            });
          }
          courseDetailLocal = {
            ...courseDetailLocal,
            is_finalized,
          };
        }

        // Pretest logic
        let isPreTest = false;
        if (courseDetailLocal) {
          if (courseDetailLocal.is_pretest_enabled && courseDetailLocal.pretest) {
            if (courseDetailLocal.pretest.is_prettest_given == null) {
              let alreadyStarted = false;
              courseDetailLocal.lessons_front.forEach((lesson) => {
                lesson.lectures.forEach((lecture) => {
                  if (lecture.attended) {
                    alreadyStarted = true;
                  }
                });
              });
              if (!alreadyStarted) {
                if (!isMounted) return;
                setCourseModalOpen('pretest_info');
                setIsModalOpen(true);
                isPreTest = true;
              }
            }
          }
        }

        if (!isMounted) return;

        setCourseDetail(courseDetailLocal);

        // Dispatch to Redux store
        dispatchToStore(courseDetailLocal, courseEbookLocal, profileDataLocal);

        // Set exam/materi state
        if (isPreTest) {
          dispatch({
            type: 'UPDATE_EXAM_OR_MATERI',
            payload: 'pretest',
          });
        } else {
          dispatch({
            type: 'UPDATE_MATERI_OPEN',
            payload: 0,
          });
          dispatch({
            type: 'UPDATE_EXAM_OR_MATERI',
            payload: 'materi',
          });
        }
      } finally {
        dispatch({ type: 'TOGGLE_LOADING_FALSE' });
      }
    };

    init();

    return () => {
      isMounted = false;
    };
  }, [slug, dispatch]);

  // componentDidUpdate untuk resource_lecture_id
  useEffect(() => {
    if (!resource_lecture_id) return;

    fetchResource(resource_lecture_id)
      .then((result) => setClassResource(result))
      .finally(() => {});
  }, [resource_lecture_id]);

  // componentWillUnmount
  useEffect(() => {
    return () => {
      removeScript('https://app.midtrans.com/snap/snap.js');
    };
  }, []);

  // Helper untuk format deskripsi
  const formatNextLine = (desc) => {
    if (!desc) return null;
    const result = desc.split('\n');

    return (
      <div className="">
        {result.map((text, i) => (
          <p className="" key={i}>
            {text}
          </p>
        ))}
      </div>
    );
  };

  const thisLesson =
    course_detail?.lessons_front && course_detail.lessons_front.length > 0
      ? course_detail.lessons_front[lesson_detail_number]
      : {};

  const thisLecture =
    thisLesson?.lectures && thisLesson.lectures.length > 0
      ? thisLesson.lectures[lecture_number]
      : {};

  const verifyCoupon = async (e, isPostTest = false) => {
    e.preventDefault();
    try {
      setLoadingVoucherKpj(true);
      const token = localStorage.getItem('access_token');

      const payload = isPostTest
        ? {
            kpj_code: kpj_code,
            sequence: 999,
            payment_id: course_detail?.payment?.id,
            quiz_id: course_detail?.quiz?.id,
          }
        : {
            kpj_code: kpj_code,
            sequence: isPostTest ? 999 : lesson_detail_number + 2,
            payment_id: course_detail?.payment?.id,
            lesson_id: thisLesson?.id,
            lecture_id: thisLecture?.id,
          };

      const res = await axios.post(`${API_URL}/kjflow/verifycoupon`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      NotificationManager.success('Success to verifiy coupon');

      if (kpj_code === KPJ_CODE_ADMIN) {
        window.location.reload();
      } else {
        window.open(res?.data?.data?.data?.url);
      }
    } catch (error) {
      NotificationManager.error(error?.response?.data?.message ?? 'Failed to verifiy coupon');
    } finally {
      setLoadingVoucherKpj(false);
    }
  };

  const goToTugasMandiriPage = async () => {
    const token = localStorage.getItem('access_token');

    try {
      setLoadingTugasMandiri(true);

      let res = await axios.post(
        `${API_URL}/kjflow/starttugasmandiri`,
        {
          lesson_id: thisLesson?.id,
          lecture_id: thisLecture?.id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (res.status === 200) {
        history.push(`/student/tugas-mandiri/${res?.data?.data?.id}`);
      }
    } catch (error) {
      NotificationManager.error(error?.response?.data?.message ?? 'Failed to verifiy coupon');
    } finally {
      setLoadingTugasMandiri(false);
    }
  };

  let contentOpened = {};

  if (course_detail) {
    contentOpened = {
      certificate_free_course: <CertificatesFreeCourse />,
      exam: (
        <div>
          {course_detail?.kartu_prakerja && !course_detail?.quiz?.is_fr_done && (
            <div>
              <div className="lesson__zoom">
                <p className="lesson__zoom__name">{course_detail?.quiz?.name ?? '-'}</p>
              </div>
              <KpjCodeVerification
                handleSubmit={(e) => verifyCoupon(e, true)}
                loadingVoucherKpj={loadingVoucherKpj}
                setVoucherKpj={(e) => setKpjCode(e)}
                voucherKpj={kpj_code}
              />
            </div>
          )}
          {(course_detail?.quiz?.is_fr_done || !course_detail?.kartu_prakerja) && (
            <CourseExam
              quiz={course_detail.quiz}
              openModal={(modalStr) => {
                setCourseModalOpen(modalStr);
                setIsModalOpen(true);
              }}
              isPretest={false}
            />
          )}
        </div>
      ),
      pretest: (
        <div className="">
          <CourseExam
            quiz={course_detail.pretest}
            openModal={(modalStr) => {
              setCourseModalOpen(modalStr);
              setIsModalOpen(true);
            }}
            isPretest={true}
          />
        </div>
      ),
      finish: (
        <ExamFinish
          course_detail={course_detail}
          result={quiz_score_data}
          certificateFailed={certificate_failed}
        />
      ),
      finish_pretest: <ExamFinishPretest course_detail={course_detail} result={quiz_score_data} />,
      finish_perlecture: <ExamFinishPerLecture />,
      exam_improvement: <ExamImprovement />,
      qna: <QnA course_detail={course_detail} />,
      download: <CourseResource />,
      quizlecture: (
        <QuizPerLecture
          fillAllAnswerWarning={() => {
            setCourseModalOpen('incomplete_answer');
            setIsModalOpen(true);
          }}
        />
      ),
      materi: (
        <div>
          {course_detail?.kartu_prakerja && !thisLecture?.face_verified && (
            <div>
              <div className="lesson__zoom">
                <p className="lesson__zoom__name">{thisLesson?.name ?? '-'}</p>
              </div>
              <KpjCodeVerification
                handleSubmit={(e) => verifyCoupon(e, false)}
                loadingVoucherKpj={loadingVoucherKpj}
                setVoucherKpj={(e) => setKpjCode(e)}
                voucherKpj={kpj_code}
              />
            </div>
          )}
          {course_detail?.kartu_prakerja ? (
            <>
              {thisLecture?.face_verified && (
                <div className="">
                  {thisLesson?.start_date && thisLesson?.end_date ? (
                    <div className="lesson__zoom">
                      <p className="lesson__zoom__name">{thisLesson?.name ?? '-'}</p>
                      <p className="lesson__zoom__description">
                        {formatNextLine(thisLesson?.description) ?? '-'}
                      </p>
                      <div className="">
                        <p className="lesson__zoom__date">
                          Start date:{' '}
                          {thisLesson?.start_date
                            ? moment(thisLesson?.start_date).format('HH:mm, DD MMMM YYYY')
                            : '-'}
                        </p>
                        <p className="lesson__zoom__date">
                          End date:{' '}
                          {thisLesson?.end_date
                            ? moment(thisLesson?.end_date).format('HH:mm, DD MMMM YYYY')
                            : '-'}
                        </p>
                      </div>
                      <Button
                        className="lesson__zoom__link"
                        onClick={() => window.open(thisLesson?.zoom_link)}
                      >
                        Zoom link
                      </Button>

                      {thisLecture?.is_tugas_mandiri === 1 || thisLesson?.is_tugas_mandiri === 1 ? (
                        <button
                          className="btn btn-pink"
                          style={{ width: 'fit-content' }}
                          onClick={goToTugasMandiriPage}
                          disabled={loadingTugasMandiri}
                        >
                          {loadingTugasMandiri
                            ? 'Loading...'
                            : thisLecture?.tugas_mandiri_submitted
                            ? 'Lihat tugas yang dikumpulkan'
                            : 'Kumpulkan tugas'}
                        </button>
                      ) : (
                        ''
                      )}
                    </div>
                  ) : (
                    course_detail.type === 'hosted' && (
                      <CourseVideo
                        CourseResource={class_resource}
                        openConnectionProblem={() => {
                          setCourseModalOpen('connection_problem');
                          setIsModalOpen(true);
                        }}
                      />
                    )
                  )}
                </div>
              )}
            </>
          ) : (
            <CourseVideo
              CourseResource={class_resource}
              openConnectionProblem={() => {
                setCourseModalOpen('connection_problem');
                setIsModalOpen(true);
              }}
            />
          )}
        </div>
      ),
      ebook: <CourseEbook />,
      howToDownload: (
        <div className="container py-10">
          <HowToDownload />
        </div>
      ),
    };
  }

  return (
    <>
      <div style={{ backgroundColor: 'white' }}>
        <Header />
        <main>
          <div className="main-container-hosted-login container mob-white">
            {isUsingSubs && (
              <WrapperSubs>
                <BadgeSubs>
                  <span className="">
                    Subscription |{' '}
                    {packageSub?.remaining_days > 0
                      ? `${packageSub?.remaining_days} Hari Tersisa`
                      : 'Langganan sudah berakhir'}
                  </span>
                </BadgeSubs>

                {packageSub?.remaining_days <= 0 && (
                  <div
                    className={`btn btn-tosca mt-1`}
                    onClick={() => {
                      window.open(
                        `${URL_MES_COURSE}/checkout?mesx_subscription_id=${packageSub?.package?.id}`,
                      );
                    }}
                    style={{
                      opacity: 1,
                      pointerEvents: 'auto',
                    }}
                  >
                    Langganan Lagi
                  </div>
                )}
              </WrapperSubs>
            )}

            {/* if not using subs and subs still active */}
            {((isUsingSubs && isActiveSub) || !isUsingSubs) && (
              <div className="row main-row disqus-row">
                <div className="col-12 col-lg-5 col-xl-5" style={{ padding: 0 }}>
                  <MediaQuery minDeviceWidth={991}>
                    <div className="navbar-desc">
                      <Title />
                      <CourseNav
                        openModal={(modalName) => {
                          setCourseModalOpen(modalName);
                          setIsModalOpen(true);
                        }}
                      />
                    </div>
                  </MediaQuery>

                  {/* for mobile */}
                  <MediaQuery maxDeviceWidth={991}>
                    <div className="navbar-mob">
                      {course_detail && contentOpened[materiExamOpened]}
                      <CourseNav
                        openModal={(modalName) => {
                          setCourseModalOpen(modalName);
                          setIsModalOpen(true);
                        }}
                      />
                      {course_detail && <Person instructor={course_detail.instructor} />}
                    </div>
                  </MediaQuery>
                </div>

                {/* for desktop */}
                <MediaQuery minDeviceWidth={991}>
                  <StickyContainer
                    style={{
                      flex: '0 0 58.33333%',
                      maxWidth: '58.33333%',
                      paddingLeft: '16px',
                    }}
                  >
                    <Sticky topOffset={300} bottomOffset={100}>
                      {({ style }) => (
                        <div
                          className="navbar-desc"
                          style={{ ...style, top: `${97.33 + style.top}px` }}
                        >
                          {course_detail && contentOpened[materiExamOpened]}
                          {course_detail && <Person instructor={course_detail.instructor} />}
                        </div>
                      )}
                    </Sticky>
                  </StickyContainer>
                </MediaQuery>
              </div>
            )}
          </div>
        </main>
        <Footer />
        <CourseModal
          modalOpened={courseModalOpen}
          isModalOpen={isModalOpen}
          closeModal={() => {
            setIsModalOpen(false);
            dispatch({
              type: 'QUIZ_POPUP_TYPE',
              payload: '',
            });
            dispatch({
              type: 'FILL_ALL_QUIZ_QUESTION',
              payload: false,
            });
          }}
        />
        {isLoading ? <LoadingSpinner text={''} /> : ''}
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    course_detail: state.course_detail,
    materi_open_id: state.materi_open_id,
    materiExamOpened: state.materi_exam_opened,
    quiz_score_data: state.quiz_score_data,
    isLoading: state.isLoading,
    lesson_detail_number: state.lesson_detail_number,
    lecture_number: state.lecture_number,
    resource_lecture_id: state.materi_open_id,
    certificate_failed: state.certificate_failed,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CourseDetail);
